// extracted by mini-css-extract-plugin
export var currencyInput = "_oc-1";
export var currencySymbol = "_oc-0";